var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1836 4.67676L15.8531 17.5377C15.7435 18.5979 14.9453 19.3975 13.9967 19.3975H6.66488C5.71629 19.3975 4.91815 18.5979 4.80847 17.5377L3.47803 4.67676",
    stroke: "white",
    strokeWidth: 1.01739
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.78271 4.75008H18.7392H1.78271Z",
    stroke: "white",
    strokeWidth: 1.01739,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4997 4.74962L14.0033 3.01205C13.7953 2.2841 13.13 1.78223 12.3729 1.78223H8.14834C7.39127 1.78223 6.72592 2.2841 6.51793 3.01205L6.02148 4.74962",
    stroke: "white",
    strokeWidth: 1.01739
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2607 6.86914L10.2607 17.0431",
    stroke: "white",
    strokeWidth: 1.01739
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.86963 6.86914L7.71746 17.0431",
    stroke: "white",
    strokeWidth: 1.01739
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6523 6.86914L12.8045 17.0431",
    stroke: "white",
    strokeWidth: 1.01739
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.a88936b8bce5c83f3475ae3d4ee1b3f3.svg";
export { ForwardRef as ReactComponent };